import { Dialog } from '@busybusy/webapp-react-ui';
import classNames from 'classnames';
import { ClassName } from "types/ClassName";
import ProDetailsItem from 'components/foundation/details-item/ProDetailsItem/ProDetailsItem';
import { useOpenable } from 'hooks';
import { t } from 'i18next';
import { isNil } from 'lodash';

import { JobCostingPromptOptions } from '__generated__/graphql';
import IPosition from 'types/Position';
import { useFeatureFlags } from 'utils/features';
import { executeFunctionsCurried } from 'utils/functionUtils';
import JobCostingPromptForm from '../forms/JobCostingPromptForm';

export interface IJobCostingPromptDetailProps {
  className?: ClassName;
  editable: boolean;
  position: IPosition;
  onUpdate: () => Promise<any>;
}

const JobCostingPromptDetail = (props: IJobCostingPromptDetailProps) => {
  const { className, position, editable, onUpdate } = props;

  const formOpenable = useOpenable();
  const isPro = useFeatureFlags('PRO');

  function getPositionValue() {
    if (!isNil(position.jobCostingPrompt)) {
      switch (position.jobCostingPrompt) {
        case JobCostingPromptOptions.Off:
          return t('Off');
        case JobCostingPromptOptions.On:
          return t('On');
        case JobCostingPromptOptions.Required:
          return t('On (Required)');
      }
    }
    return t('Off');
  }

  const classes = classNames('job-costing-prompt-detail', className);

  return (
    <>
      <ProDetailsItem
        title={t('Job Costing Prompt')}
        onClick={formOpenable.open}
        value={getPositionValue()}
        hint={
          'When clocking out, prompt the employees to use the job costing tool to edit the time spent on projects, cost codes and equipment. They will not be able to edit their total time worked for the day if they do not already have permissions to do so.'
        }
        className={classes}
        disabled={!editable || !isPro}
      />
      <Dialog position={'center'} isOpen={formOpenable.isOpen} onClose={formOpenable.close}>
        <JobCostingPromptForm
          className="mt-4 p-8"
          position={position}
          onSubmit={executeFunctionsCurried(onUpdate, formOpenable.close)}
        />
      </Dialog>
    </>
  );
};

export default JobCostingPromptDetail;
